import { useEffect, useRef, useState } from 'react';

import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

import Dot from '../Dot/Dot';

import {
  hideDefaultIntercomLauncher,
  initializeIntercom,
  injectIntercomStyles,
  resetMessengerPosition,
  setupIntercomEventHandlers,
  showDefaultIntercomLauncher,
  waitForMessengerAndPosition
} from './lib/helpers';

/**
 * @param {import('./lib/propTypes').IntercomButtonProps}
 */

const IntercomButton = ({ className, iconColor }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const ignoreResets = useRef(true);
  const styleRef = useRef(null);

  useEffect(() => {
    styleRef.current = injectIntercomStyles();

    const intervalId = initializeIntercom(() => {
      setupIntercomEventHandlers(setIsOpen, setUnreadCount, ignoreResets);

      const initialCount = window.Intercom('getUnreadCount');
      if (initialCount !== undefined && initialCount > 0) {
        setUnreadCount(initialCount);
      }
    });

    return () => {
      clearInterval(intervalId);

      if (window.Intercom) {
        window.Intercom('hide');

        showDefaultIntercomLauncher();

        resetMessengerPosition();
      }

      if (styleRef.current) {
        document.head.removeChild(styleRef.current);
      }
    };
  }, []);

  const toggleIntercom = () => {
    if (!window.Intercom) return;

    if (isOpen) {
      window.Intercom('hide');
      setIsOpen(false);
      ignoreResets.current = true;
    } else {
      hideDefaultIntercomLauncher();

      window.Intercom('show');
      setIsOpen(true);
      setUnreadCount(0);
      ignoreResets.current = false;

      waitForMessengerAndPosition();
    }
  };

  return (
    <div className="relative">
      <Icon
        className={cn('flex size-[24px] select-none items-center justify-center', className)}
        color={iconColor}
        icon="intercom-mono"
        onClick={toggleIntercom}
        data-intercom-trigger="true"
      />
      {unreadCount > 0 && (
        <div className="absolute right-0 top-0">
          <Dot size="sm" color="danger" />
        </div>
      )}
    </div>
  );
};

export default IntercomButton;
